
const heroSectionDataAr = {
    title : "نهجنا في التعامل مع الممارسات البيئية والاجتماعية والحوكمة المؤسسية",
    // subtitle : "نؤمن إيمانًا راسخًا بأن البنك السعودي الأول يضطلع بدور فريد في المجتمع وبقدرتنا على ممارسة الأعمال بطريقة تعود بالنفع على جميع المستويات، وهو ما لن ندخر جهدًا في تحقيقه.",
    subtitle : "نحن نؤمن بأن الأول له دور فريد في المجتمع ، وأنه يمكننا قيادة التغيير التحويلي في المملكة"
}

export default heroSectionDataAr;